import React, {useCallback, useState} from "react";
import {Alert, Button, Check, Modal, TextInput} from "../common";
import styles from "../common/_Modal/_Modal.module.scss";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import RegularText from "../common/_RegularText";
import StandardText from "../common/_StandardText";

const VALIDATION_SCHEMA = Yup.object().shape({
    ticket: Yup.string().required("formModal.required")
});

function DeleteUserModal({show, setShow, setRemoveAlertMessage, id, userAccounts}) {
    const [formError, setFormError] = useState(false);

    const handleClose = useCallback(() => {
        setFormError(false)
        setShow(false)
    }, [setShow]);

    const removeUser = useCallback((ticketNumber, accounts) => {
        return axios.post("/api/approvals/create-request", {
            action: "deleting-user",
            reason: ticketNumber,
            details: {id: id, ticketNumber: ticketNumber, accounts: accounts},
            attribute: "id",
            value: id.toString()})
            .then(({data}) => {
                if (data.requestExists) {
                    return setFormError(true);
                } else {
                    handleClose();
                    const messageKey = data.pendingApproval
                        ? "specific.removeUserSuccess"
                        : "specific.deleteUserAutoApproved";
                    setTimeout(() => setRemoveAlertMessage(null), 6000);
                    setRemoveAlertMessage(messageKey);
                }
            })
    }, [id, setRemoveAlertMessage, handleClose]);

    const handleSubmit = useCallback((values, {setSubmitting}) => {
        const accountsToDelete = Object.keys(values).filter(val => val !== "ticket" && values[val]);
        setSubmitting(true);
        removeUser(values.ticket, accountsToDelete)
            .finally(() => setSubmitting(false))
    }, [removeUser]);

    const hasAccounts = userAccounts.length > 0;

    return (
        <Modal header={"specific.modal.deleteHeader"} show={show} setShow={setShow} handleClose={handleClose}>
            <Formik
                initialValues={{ticket: ''}}
                validationSchema={VALIDATION_SCHEMA}
                onSubmit={handleSubmit}
            >
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    errors,
                    touched,
                    setFieldValue,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <b><label htmlFor="ticket">{<RegularText text={"specific.modal.deleteMessage"}/>}</label></b>
                        <TextInput id="ticket"
                            placeholder={"specific.modal.messagePlaceholder"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.ticket}
                            errors={errors.ticket}
                            touched={touched.ticket}/>
                        {hasAccounts &&
                            <b><label htmlFor="checkBox">
                                <RegularText text={"specific.modal.accDeleteMessage"}/></label></b>}
                        <Check options={userAccounts} id={"checkbox"} setFieldValue={setFieldValue}/>
                        {formError &&
                            <Alert variant={"danger"}><StandardText text={"specific.modal.userAlreadyScheduled"}/></Alert>}
                        <Modal.Footer>
                            <Button label={"specific.modal.buttonCancel"} variant={"secondary"} onClick={handleClose} type="button"/>
                            <Button label={"specific.modal.buttonDeleteUser"} variant={"danger"} loading={isSubmitting}
                                type="submit" className={styles.submitButton}/>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export {DeleteUserModal};
